class LocalStorageProxy {

  constructor() {
    this._isAvailable = 'localStorage' in window
  }
  
  set(name, value) {
    if(!this._isAvailable) return;
    localStorage.setItem(name, value)
  }
  
  get(name) {
    if(!this._isAvailable) return;
    return localStorage.getItem(name)
  }
}

export {
  LocalStorageProxy
}


// WEBPACK FOOTER //
// ./scripts/utils/storage.js